<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="名称">
                <el-input v-model="formInline.resourceName" placeholder="名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="类型">
                <el-select :popper-append-to-body="true" v-model="formInline.resourceType">
                    <el-option
                            v-for="item in typeList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="resourceId" label="资源标示"></el-table-column>
            <el-table-column prop="resourceName" label="名称"></el-table-column>
            <el-table-column prop="resourceType" :formatter="convertType" label="类型"></el-table-column>
            <el-table-column prop="resourceUrl" label="资源路径"></el-table-column>
            <el-table-column prop="resourceIcon" label="资源图标"></el-table-column>
            <el-table-column prop="resourceOrder" label="排序" width="50" sortable></el-table-column>
            <el-table-column prop="status" :formatter="convertStatus" label="状态"></el-table-column>
            <el-table-column label="操作" fixed="right" width="240">
                <template slot-scope="scope">
                    <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="success " size="mini" v-if="scope.row.resourceType==1" @click="handledMenus(scope.row)">子菜单</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="资源/菜单管理" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="名称" :required="true">
                    <el-input v-model="form.resourceName" placeholder="名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select :popper-append-to-body="true" v-model="form.resourceType">
                        <el-option
                                v-for="item in typeList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="资源路径">
                    <el-input  v-model="form.resourceUrl" placeholder="类型为资源时候添加" clearable></el-input>
                </el-form-item>
                <el-form-item label="资源图标">
                    <el-input  v-model="form.resourceIcon" placeholder="如果是资源不需要填写" clearable></el-input>
                    http://element.eleme.io/#/zh-CN/component/icon 选一个 如果是资源不需要填写
                </el-form-item>
                <el-form-item label="排序" :required="true">
                    <el-input-number  v-model="form.resourceOrder" :min="1" :max="1000" placeholder="排序" clearable></el-input-number>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select :popper-append-to-body="true" v-model="form.status">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAdd">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog  title="子菜单管理" :visible.sync="dialogFormVisibleleaf" center :fullscreen="true">
            <el-form :inline="true" :model="leafForm" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item>
                    <el-button type="primary" @click="getLeafList">查询</el-button>
                    <el-button type="success" @click="handleAddLeaf">新增</el-button>
                    <el-button type="warning" @click="dialogFormVisibleleaf = false">关闭</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="dataLeafList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading1">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="resourceId" label="资源标示"></el-table-column>
                <el-table-column prop="resourceName" label="名称"></el-table-column>
                <el-table-column prop="resourceType" :formatter="convertType" label="类型"></el-table-column>
                <el-table-column prop="resourceHtmlUrl" label="菜单路径"></el-table-column>
                <el-table-column prop="resourceUrl" label="资源路径"></el-table-column>
                <el-table-column prop="resourceOrder" label="排序" sortable></el-table-column>
                <el-table-column prop="status" :formatter="convertStatus" label="状态"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button type="warning " size="mini" @click="handleUpdateLeaf(scope.row)">修改</el-button>
                        <el-button type="success " size="mini" @click="handleGroup(scope.row)">用户组</el-button>
                     </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="leafForm.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="leafForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="leafForm.recordsTotal">
                </el-pagination>
            </div>
            <el-dialog title="子菜单管理" :visible.sync="dialogFormVisibleLeafDetail" center  append-to-body>
                <el-form :model="formLeafDetail" label-width="120px">
                    <el-form-item label="名称" :required="true">
                        <el-input v-model="formLeafDetail.resourceName" placeholder="名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="菜单路径" :required="true">
                        <el-input v-model="formLeafDetail.resourceHtmlUrl" placeholder="菜单路径" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="资源路径">
                        <el-input  v-model="formLeafDetail.resourceUrl" placeholder="资源路径" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="排序" :required="true">
                        <el-input-number  v-model="formLeafDetail.resourceOrder" :min="1" :max="1000" placeholder="排序" clearable></el-input-number>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select :popper-append-to-body="true" v-model="formLeafDetail.status">
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisibleLeafDetail = false">取 消</el-button>
                    <el-button type="primary" @click="updateOrAddLeaf">确 定</el-button>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        saveOrUpdateMallResource,
        getMallParentResourceList,
        getMallleafResourceList,
    } from '../../api/api'


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                dataLeafList: [],
                statusList: [{value: 1, name: '有效'}, {value: -1, name: '无效'}],
                typeList: [{value: 1, name: '菜单'}, {value: 2, name: '资源'}],
                loading: true,
                loading1: true,
                dialogFormVisible: false,
                dialogFormVisibleleaf:false,
                dialogFormVisibleLeafDetail:false,
                formInline: {
                    resourceName: "",
                    resourceType: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                leafForm:{
                    resourceId:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                form: {
                    resourceId: '',
                    resourceParentId: '',
                    resourceName: '',
                    resourceType: '',
                    resourceHtmlUrl:'',
                    resourceUrl:'',
                    resourceOrder:'',
                    resourceIcon:'',
                    status:1
                },
                formLeafDetail: {
                    resourceId: '',
                    resourceParentId: '',
                    resourceName: '',
                    resourceType: 1,
                    resourceHtmlUrl:'',
                    resourceUrl:'',
                    resourceOrder:'',
                    status:1
                },
            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
        },
        methods: {
            getList() {
                this.loading = true;
                getMallParentResourceList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd() {
                this.form= {
                    resourceId: '',
                    resourceParentId: 0,
                    resourceName: '',
                    resourceType: '',
                    resourceHtmlUrl:'',
                    resourceUrl:'',
                    resourceOrder:'',
                    status:1
                }
                this.dialogFormVisible = true;
            },
            handleUpdate(row) {
                this.form= {
                    resourceId:row.resourceId,
                    resourceParentId: row.resourceParentId,
                    resourceName:row.resourceName,
                    resourceType:row.resourceType,
                    resourceHtmlUrl: row.resourceHtmlUrl,
                    resourceUrl:row.resourceUrl,
                    resourceOrder:row.resourceOrder,
                    status: row.status,
                    resourceIcon:row.resourceIcon,
                }
                this.dialogFormVisible = true;
            },
            updateOrAdd() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateMallResource(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },

            handledMenus(row) {
                this.leafForm.resourceId=row.resourceId;
                this.formLeafDetail.resourceParentId=row.resourceId;
                this.dialogFormVisibleleaf = true;
                this.getLeafList();
            },

            handleGroup(row) {
                this.$router.push({path:'/sysresourcegroup',query:{resourceId:row.resourceId}})
            },

            getLeafList() {
                this.loading1 = true;
                getMallleafResourceList(this.leafForm).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.leafForm.recordsTotal = res.data.value.total;
                        this.dataLeafList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange1(val) {
                this.leafForm.pageSize = val;
                this.getLeafList()
            },
            handleCurrentChange1(val) {
                this.leafForm.currentPage = val;
                this.getLeafList()
            },
            handleAddLeaf() {
                this.formLeafDetail.resourceId='';
                this.dialogFormVisibleLeafDetail = true;
            },
            handleUpdateLeaf(row) {
                this.formLeafDetail.resourceId=row.resourceId;
                this.formLeafDetail.resourceName=row.resourceName;
                this.formLeafDetail.resourceHtmlUrl= row.resourceHtmlUrl;
                this.formLeafDetail.resourceUrl=row.resourceUrl;
                this.formLeafDetail.resourceOrder=row.resourceOrder;
                this.formLeafDetail.status= row.status;
                this.dialogFormVisibleLeafDetail = true;
            },
            updateOrAddLeaf() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateMallResource(this.formLeafDetail).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getLeafList();
                        this.dialogFormVisibleLeafDetail = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "有效";
                } else {
                    return "无效";
                }
            },
            convertType(row, column, cellValue){
                if (row.resourceType == 1) {
                    return "菜单";
                } else {
                    return "资源";
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/sys/resource.vue